import React from 'react';

import { createTheme, Theme } from '@mui/material';

import { theme } from 'src/theme';

import { ThemeContext, ThemeContextType } from './ThemeContext';

export const ThemeProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [customTheme, setCustomTheme] = React.useState<Partial<Theme>>({});
  const [themeWasChanged, setThemeWasChanged] = React.useState(false);

  const handleSetCustomTheme: ThemeContextType['setCustomTheme'] = React.useCallback(
    customTheme => {
      setCustomTheme(customTheme);
      setThemeWasChanged(true);
    },
    [],
  );

  const appTheme = React.useMemo((): ThemeContextType['appTheme'] => {
    return createTheme(theme, customTheme);
  }, [customTheme]);

  const contextValue = React.useMemo((): ThemeContextType => {
    return {
      appTheme,
      setCustomTheme: handleSetCustomTheme,
      themeWasChanged,
      setThemeWasChanged,
    };
  }, [appTheme, handleSetCustomTheme, themeWasChanged]);

  return <ThemeContext.Provider value={contextValue}>{children}</ThemeContext.Provider>;
};
